import { useEffect } from 'react';

export type ApplicationEvents = 'trigger_collapse' | 'kebab_open_event';

export const useEventListener = (eventName: ApplicationEvents, handler: (event: Event) => void) => {
  useEffect(() => {
    window.addEventListener(eventName, handler, false);

    return () => {
      window.removeEventListener(eventName, handler, false);
    };
  }, [handler]);
};

export const emitEvent = (eventName: ApplicationEvents, detail?: any) => {
  const event = new CustomEvent(eventName, { detail });
  window.dispatchEvent(event);
};
